import { useEffect, useRef } from 'react';
import Icon from './Icon';
import { cx } from './util';

// §2.6 Menu (lives inside a Popover). items: [{ label, icon?, onSelect, danger?, disabled?, title?, testId? } | { separator: true }].
// title: a tooltip (why an item is disabled); testId: a data-testid on the item's button (a hook for the harness).
// Arrow keys move, Enter selects; the first item takes focus when the menu opens.
export default function Menu({ items, onClose, label }) {
  const list = useRef(null);
  useEffect(() => { list.current?.querySelector('button:not(:disabled)')?.focus(); }, []);
  const onKey = e => {
    const btns = [...list.current.querySelectorAll('button:not(:disabled)')];
    const i = btns.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); btns[(i + 1) % btns.length]?.focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); btns[(i - 1 + btns.length) % btns.length]?.focus(); }
  };
  return (
    <ul className="ui ui-menu" role="menu" aria-label={label} ref={list} onKeyDown={onKey}>
      {items.map((it, i) => it.separator
        ? <li key={`s${i}`} className="ui-menu__sep" role="separator" />
        : (
          <li key={`${i}:${it.label}`} role="none">
            <button type="button" role="menuitem" className={cx('ui-menu__item', it.danger && 'ui-menu__item--danger')} disabled={it.disabled} title={it.title} data-testid={it.testId}
              onClick={() => { it.onSelect?.(); onClose?.(); }}>
              {it.icon && <Icon icon={it.icon} />}{it.label}
            </button>
          </li>
        ))}
    </ul>
  );
}
